
export const DISCIPLINES = [
  { id: '3d-artist', label: '3D Artist' },
  { id: 'animator', label: 'Animator' },
  { id: 'art-director', label: 'Art Director' },
  { id: 'brand-designer', label: 'Brand Designer' },
  { id: 'content-designer', label: 'Content Designer' },
  { id: 'creative-director', label: 'Creative Director' },
  { id: 'design-educator', label: 'Design Educator' },
  { id: 'design-researcher', label: 'Design Researcher' },
  { id: 'design-strategist', label: 'Design Strategist' },
  { id: 'experience-designer', label: 'Experience Designer' },
  { id: 'game-designer', label: 'Game Designer' },
  { id: 'graphic-designer', label: 'Graphic Designer' },
  { id: 'illustrator', label: 'Illustrator' },
  { id: 'motion-designer', label: 'Motion Designer' },
  { id: 'multimedia-producer', label: 'Multimedia Producer' },
  { id: 'product-designer', label: 'Product Designer' },
  { id: 'service-designer', label: 'Service Designer' },
  { id: 'ui-designer', label: 'UI Designer' },
  { id: 'ux-designer', label: 'UX Designer' },
  { id: 'visual-designer', label: 'Visual Designer' },
  { id: 'web-designer', label: 'Web Designer' },
  { id: 'web-developer', label: 'Web Developer' }
];

// Re-export countries from the dedicated countries file
export { ALL_COUNTRIES, AFRICAN_COUNTRIES } from './countries';

export const EDUCATION_LEVELS = [
  { id: 'high_school', label: 'High school diploma or equivalent (e.g., GED)' },
  { id: 'bachelors', label: 'Bachelor\'s degree' },
  { id: 'mba', label: 'MBA International Business Management' },
  { id: 'masters', label: 'Master\'s degree' },
  { id: 'doctorate', label: 'Doctorate (Ph.D., Ed.D., etc.)' }
];

export const EXPERIENCE_LEVELS = [
  { id: 'less_than_1', label: 'Less than 1 year' },
  { id: '1_to_2', label: '1-2 years' },
  { id: '3_to_5', label: '3-5 years' },
  { id: '6_to_10', label: '6-10 years' },
  { id: '11_to_15', label: '11-15 years' },
  { id: '16_to_20', label: '16-20 years' },
  { id: 'more_than_20', label: 'More than 20 years' }
];

// Synced with database languages table codes
export const LANGUAGES = [
  { id: 'afrikaans', label: 'Afrikaans' },
  { id: 'amharic', label: 'Amharic' },
  { id: 'arabic', label: 'Arabic' },
  { id: 'bengali', label: 'Bengali' },
  { id: 'bulgarian', label: 'Bulgarian' },
  { id: 'chinese', label: 'Chinese' },
  { id: 'chinese-cantonese', label: 'Chinese (Cantonese)' },
  { id: 'chinese-mandarin', label: 'Chinese (Mandarin)' },
  { id: 'czech', label: 'Czech' },
  { id: 'danish', label: 'Danish' },
  { id: 'dutch', label: 'Dutch' },
  { id: 'english', label: 'English' },
  { id: 'filipino', label: 'Filipino' },
  { id: 'finnish', label: 'Finnish' },
  { id: 'french', label: 'French' },
  { id: 'german', label: 'German' },
  { id: 'greek', label: 'Greek' },
  { id: 'gujarati', label: 'Gujarati' },
  { id: 'hausa', label: 'Hausa' },
  { id: 'hebrew', label: 'Hebrew' },
  { id: 'hi', label: 'Hindi' },
  { id: 'hungarian', label: 'Hungarian' },
  { id: 'ig', label: 'Igbo' },
  { id: 'indonesian', label: 'Indonesian' },
  { id: 'italian', label: 'Italian' },
  { id: 'ja', label: 'Japanese' },
  { id: 'kannada', label: 'Kannada' },
  { id: 'ko', label: 'Korean' },
  { id: 'malay', label: 'Malay' },
  { id: 'malayalam', label: 'Malayalam' },
  { id: 'marathi', label: 'Marathi' },
  { id: 'norwegian', label: 'Norwegian' },
  { id: 'persian', label: 'Persian' },
  { id: 'polish', label: 'Polish' },
  { id: 'portuguese', label: 'Portuguese' },
  { id: 'punjabi', label: 'Punjabi' },
  { id: 'romanian', label: 'Romanian' },
  { id: 'ru', label: 'Russian' },
  { id: 'spanish', label: 'Spanish' },
  { id: 'sw', label: 'Swahili' },
  { id: 'swedish', label: 'Swedish' },
  { id: 'tamil', label: 'Tamil' },
  { id: 'telugu', label: 'Telugu' },
  { id: 'thai', label: 'Thai' },
  { id: 'turkish', label: 'Turkish' },
  { id: 'urdu', label: 'Urdu' },
  { id: 'vietnamese', label: 'Vietnamese' },
  { id: 'indonesian', label: 'Indonesian' },
  { id: 'malay', label: 'Malay' },
  { id: 'filipino', label: 'Filipino' },
  { id: 'swahili', label: 'Swahili' },
  { id: 'amharic', label: 'Amharic' },
  { id: 'yoruba', label: 'Yoruba' },
  { id: 'igbo', label: 'Igbo' },
  { id: 'hausa', label: 'Hausa' },
  { id: 'zulu', label: 'Zulu' },
  { id: 'xhosa', label: 'Xhosa' },
  // European languages
  { id: 'estonian', label: 'Estonian' },
  { id: 'latvian', label: 'Latvian' },
  { id: 'lithuanian', label: 'Lithuanian' },
  { id: 'icelandic', label: 'Icelandic' },
  { id: 'maltese', label: 'Maltese' },
  { id: 'croatian', label: 'Croatian' },
  { id: 'serbian', label: 'Serbian' },
  { id: 'slovenian', label: 'Slovenian' },
  { id: 'slovak', label: 'Slovak' },
  { id: 'albanian', label: 'Albanian' },
  { id: 'macedonian', label: 'Macedonian' },
  { id: 'bosnian', label: 'Bosnian' },
  // Asian languages
  { id: 'burmese', label: 'Burmese' },
  { id: 'khmer', label: 'Khmer' },
  { id: 'lao', label: 'Lao' },
  { id: 'mongolian', label: 'Mongolian' },
  { id: 'kazakh', label: 'Kazakh' },
  { id: 'uzbek', label: 'Uzbek' },
  { id: 'tajik', label: 'Tajik' },
  { id: 'nepali', label: 'Nepali' },
  { id: 'sinhala', label: 'Sinhala' },
  // African languages
  { id: 'somali', label: 'Somali' },
  { id: 'kinyarwanda', label: 'Kinyarwanda' },
  { id: 'luganda', label: 'Luganda' },
  { id: 'afrikaans', label: 'Afrikaans' },
  // Other
  { id: 'esperanto', label: 'Esperanto' },
  { id: 'latin', label: 'Latin' }
];

export const LANGUAGE_PROFICIENCY_LEVELS = [
  { id: 'beginner', label: 'Beginner' },
  { id: 'intermediate', label: 'Intermediate' },
  { id: 'advanced', label: 'Advanced' },
  { id: 'native', label: 'Native' }
];

// Skills associated with different disciplines
export const DISCIPLINES_SKILLS = [
  {
    discipline: '3D Artist',
    skills: ['3D Modeling', 'Texturing', 'Rendering', 'Animation', 'Rigging', 'Blender', 'Maya', 'ZBrush', 'Substance Painter', 'Arnold']
  },
  {
    discipline: 'Animator',
    skills: ['2D Animation', '3D Animation', 'Character Animation', 'Motion Graphics', 'Storyboarding', 'After Effects', 'Toon Boom', 'Spine', 'Adobe Animate', 'Cinema 4D']
  },
  {
    discipline: 'Art Director',
    skills: ['Team Management', 'Creative Direction', 'Brand Strategy', 'Project Planning', 'Client Relations', 'Visual Design', 'Presentation Skills', 'Adobe Creative Suite', 'Concept Development', 'Marketing']
  },
  {
    discipline: 'Brand Designer',
    skills: ['Logo Design', 'Brand Identity', 'Style Guides', 'Typography', 'Color Theory', 'Illustrator', 'Packaging Design', 'Brand Strategy', 'Visual Communication', 'Marketing Collateral']
  },
  {
    discipline: 'Content Designer',
    skills: ['Content Strategy', 'Copywriting', 'Information Architecture', 'UX Writing', 'Content Auditing', 'SEO', 'CMS Management', 'Storytelling', 'Editing', 'Research']
  },
  {
    discipline: 'Creative Director',
    skills: ['Leadership', 'Strategic Thinking', 'Creative Vision', 'Project Management', 'Client Management', 'Branding', 'Campaign Development', 'Team Building', 'Pitch Presentations', 'Budget Management']
  },
  {
    discipline: 'Design Educator',
    skills: ['Curriculum Development', 'Teaching', 'Workshop Facilitation', 'Public Speaking', 'Educational Content Creation', 'Assessment', 'Mentoring', 'Design Theory', 'Research', 'Academic Writing']
  },
  {
    discipline: 'Design Researcher',
    skills: ['User Research', 'Qualitative Methods', 'Quantitative Methods', 'Interview Techniques', 'Survey Design', 'Data Analysis', 'Usability Testing', 'Ethnography', 'Research Planning', 'Reporting']
  },
  {
    discipline: 'Design Strategist',
    skills: ['Strategic Planning', 'Business Analysis', 'Systems Thinking', 'Workshop Facilitation', 'Stakeholder Management', 'Service Design', 'Product Strategy', 'Innovation', 'Market Research', 'Human-Centered Design']
  },
  {
    discipline: 'Experience Designer',
    skills: ['User-Centered Design', 'Interaction Design', 'Wireframing', 'Prototyping', 'Information Architecture', 'User Research', 'Sketch', 'Figma', 'Adobe XD', 'User Testing']
  },
  {
    discipline: 'Game Designer',
    skills: ['Game Mechanics', 'Level Design', 'Character Design', 'Unity', 'Unreal Engine', 'Prototyping', 'Narrative Design', 'Game Balance', 'UI/UX Design', 'Play Testing']
  },
  {
    discipline: 'Graphic Designer',
    skills: ['Typography', 'Layout Design', 'Print Design', 'Digital Design', 'Branding', 'Adobe Creative Suite', 'Illustrator', 'InDesign', 'Photoshop', 'Visual Communication']
  },
  {
    discipline: 'Illustrator',
    skills: ['Digital Illustration', 'Hand Drawing', 'Character Design', 'Concept Art', 'Editorial Illustration', 'Adobe Illustrator', 'Procreate', 'Storyboarding', 'Visual Storytelling', 'Vector Graphics']
  },
  {
    discipline: 'Motion Designer',
    skills: ['Animation', 'After Effects', 'Cinema 4D', 'Storyboarding', 'Visual Effects', 'Compositing', 'Character Animation', 'Kinetic Typography', '3D Animation', 'Video Editing']
  },
  {
    discipline: 'Multimedia Producer',
    skills: ['Video Production', 'Audio Production', 'Project Management', 'Storyboarding', 'Editing', 'Adobe Premiere', 'After Effects', 'Audio Editing', 'Production Planning', 'Direction']
  },
  {
    discipline: 'Product Designer',
    skills: ['User Experience (UX)', 'User Interface (UI)', 'Wireframing', 'Prototyping', 'User Research', 'Visual Design', 'Figma', 'Sketch', 'Design Systems', 'Usability Testing']
  },
  {
    discipline: 'Service Designer',
    skills: ['Service Blueprinting', 'Journey Mapping', 'Stakeholder Management', 'System Design', 'User Research', 'Workshop Facilitation', 'Business Analysis', 'Process Design', 'Change Management', 'Strategic Thinking']
  },
  {
    discipline: 'UI Designer',
    skills: ['Visual Design', 'Interface Design', 'Prototyping', 'Wireframing', 'Design Systems', 'Typography', 'Color Theory', 'Figma', 'Sketch', 'Adobe XD']
  },
  {
    discipline: 'UX Designer',
    skills: ['User Research', 'Wireframing', 'Prototyping', 'Usability Testing', 'Information Architecture', 'Interaction Design', 'User Flows', 'Personas', 'Heuristic Evaluation', 'A/B Testing']
  },
  {
    discipline: 'Visual Designer',
    skills: ['Visual Communication', 'Brand Identity', 'Typography', 'Color Theory', 'Layout Design', 'Adobe Creative Suite', 'Illustration', 'Iconography', 'Digital Design', 'Design Systems']
  },
  {
    discipline: 'Web Designer',
    skills: ['HTML/CSS', 'Responsive Design', 'UI Design', 'Wireframing', 'Prototyping', 'WordPress', 'JavaScript', 'Visual Design', 'Adobe XD', 'Figma']
  },
  {
    discipline: 'Web Developer',
    skills: ['HTML', 'CSS', 'JavaScript', 'React', 'Vue.js', 'Angular', 'Node.js', 'Responsive Design', 'Git', 'API Integration']
  }
];
